import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import { Trans } from 'react-i18next';
import ProductLayer from '../ProductLayer';
import usePrevious from '../../hooks/usePrevious';
import AppTypeContext from '../../contexts/AppTypeContext';
import API from '../../services/API';

import i18next from '../../translations/i18n';

const UnderlyingCard = ({ underlying, setOpenModal, postTitle }) => {
  const prevCount = usePrevious(underlying.chg);
  const [className, setClassName] = useState('');
  const [openLayer, setOpenLayer] = useState(false);
  const appName = useContext(AppTypeContext);

  const [bg, setBg] = useState(
    `rgba(${[
      underlying.color.r,
      underlying.color.g,
      underlying.color.b,
      underlying.color.a,
    ].join(',')})`,
  );

  useEffect(() => {
    if (prevCount !== underlying.chg) {
      setClassName('blink');
      setBg(
        `rgba(${[
          underlying.color.r,
          underlying.color.g,
          underlying.color.b,
          underlying.color.a,
        ].join(',')})`,
      );
    }
    setTimeout(() => {
      setClassName('');
    }, 1000);
    setOpenModal(document.querySelectorAll('.underlying-modal').length > 0);
  }, [underlying, openLayer]);

  return (
    <React.Fragment key={underlying.name}>
      <Card
        style={{ maxWidth: '40rem', background: bg }}
        onMouseEnter={() => {
          setBg(
            `rgba(${[
              underlying.color.r,
              underlying.color.g,
              underlying.color.b,
              0.7,
            ].join(',')})`,
          );
        }}
        onMouseLeave={() => {
          setBg(
            `rgba(${[
              underlying.color.r,
              underlying.color.g,
              underlying.color.b,
              underlying.color.a,
            ].join(',')})`,
          );
        }}
        size="lg"
        className={`underlying mb-4 rounded-1 ${className}`}
      >
        <Card.Body className="p-4 pt-2 pb-2">
          <Card.Text className="underlying-txt">
            <Trans>{underlying.name}</Trans>
          </Card.Text>
          <div className="d-flex justify-content-between">
            <Card.Title className="align-self-center m-0">
              {underlying.chg}%
            </Card.Title>
            <Card.Text className="">
              {i18next.t('viewProducts')}
              <span className="right-arrow" />
            </Card.Text>
          </div>
          <Card.Link
            type={`${appName}-${postTitle}`}
            name={underlying.name}
            className="stretched-link underlying-txt"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              API.sendToGA(
                postTitle
                  ? `${appName}-${postTitle}-${underlying.name}`
                  : `${appName}-${underlying.name}`,
              );
              setOpenLayer(!openLayer);
            }}
          />
        </Card.Body>
      </Card>
      {openLayer && (
        <ProductLayer
          postTitle={postTitle}
          product={underlying}
          show
          onHide={() => setOpenLayer(false)}
          onEscapeKeyDown={(e) => {
            e.preventDefault();
            setOpenLayer(false);
          }}
          style={{ opacity: openLayer ? 1 : 0 }}
        />
      )}
    </React.Fragment>
  );
};
UnderlyingCard.propTypes = {
  underlying: PropTypes.shape({
    name: PropTypes.string.isRequired,
    chg: PropTypes.string.isRequired,
    color: PropTypes.shape({
      r: PropTypes.number.isRequired,
      g: PropTypes.number.isRequired,
      b: PropTypes.number.isRequired,
      a: PropTypes.number.isRequired,
    }),
  }).isRequired,
  setOpenModal: PropTypes.func.isRequired,
  postTitle: PropTypes.string.isRequired,
};

export default UnderlyingCard;
